import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { flow } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useQuery } from 'react-query';


export const useGetCleanRoomFlowRunReportFilters = ({
  crId, runId, nodeID, enabled,
}) => {
  const dispatch = useDispatch();
  const { ID: orgId } = useSelector(activeOrgSelector);

  const {
    isLoading, isError, isSuccess, data, refetch, isRefetching,
  } = useQuery(
    ['Flow-Report-Filters', orgId, nodeID],
    async () => axiosInstance.get(flow(orgId).crFlowRunReportFilters(crId, runId, nodeID)),
    {
      onError: (error) => dispatch(showAlert({ message: error.response.data.message, type: 'error' })),
      refetchOnWindowFocus: false,
      retry: false,
      enabled,
    },
  );

  return {
    isLoading, isError, isSuccess, data, refetch, isRefetching,
  };
};
